"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Input_1 = __importStar(require("./Input"));
var ValidationMessage_1 = __importDefault(require("./common/ValidationMessage"));
var Button_1 = __importStar(require("../button/Button"));
var NumberUtils_1 = require("../../utils/NumberUtils");
var Icon_1 = __importDefault(require("../icon/Icon"));
var FieldValidationState_1 = require("./common/FieldValidationState");
var InputStepper = /** @class */ (function (_super) {
    __extends(InputStepper, _super);
    function InputStepper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.value ? _this.props.value : _this.props.min.toString(),
            invalid: _this.props.invalid,
            maxDigits: NumberUtils_1.parseMaxCharacters(_this.props.min, _this.props.max)
        };
        _this.handleBlur = function (evt) {
            var minValue = _this.props.min.toString();
            var newValue = evt.currentTarget.value || minValue;
            var invalid = _this.isInvalidInput(parseInt(newValue, 10));
            _this.setState({
                value: newValue,
                invalid: invalid
            }, function () {
                _this.props.onBlur && _this.props.onBlur({ value: newValue, invalid: invalid });
            });
        };
        _this.handleChange = function (evt) {
            var newValue = evt.currentTarget.value;
            var invalid = _this.isInvalidInput(parseInt(newValue, 10));
            _this.setState({
                value: newValue,
                invalid: invalid
            }, function () {
                _this.props.onChange && _this.props.onChange({ value: newValue, invalid: invalid });
            });
        };
        _this.handleIncrementalChange = function (evt) {
            var classList = evt.currentTarget.classList;
            var delta = classList.value.includes('button-add') ? 1 : -1;
            var previousValue = parseInt(_this.state.value, 10);
            if (!isNaN(previousValue)) {
                var newValue_1 = previousValue + delta;
                var invalid_1 = _this.isInvalidInput(newValue_1);
                _this.setState({
                    value: newValue_1.toString(),
                    invalid: invalid_1
                }, function () {
                    _this.props.onChange && _this.props.onChange({ value: newValue_1.toString(), invalid: invalid_1 });
                });
            }
        };
        return _this;
    }
    InputStepper.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.value && prevProps.value !== this.props.value && this.props.value !== prevState.value) {
            this.setState({
                value: this.props.value
            });
        }
    };
    InputStepper.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, formControlProps = _a.formControlProps, invalid = _a.invalid, name = _a.name, onFocus = _a.onFocus, onKeyUp = _a.onKeyUp, title = _a.title, min = _a.min, max = _a.max;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: this.getClassNames() },
                this.getButton('remove'),
                react_1.default.createElement(Input_1.default, { classes: "input-stepper-input", disabled: disabled, floatLabel: false, formControlProps: formControlProps, invalid: invalid || this.state.invalid, label: undefined, max: max, maxDigits: this.state.maxDigits, min: min, name: name, onBlur: this.handleBlur, onChange: this.handleChange, onFocus: onFocus, onKeyUp: onKeyUp, title: title, type: Input_1.TextInputType.NUMBER, value: this.state.value, visuallyHiddenLabel: this.props.visuallyHiddenLabel }),
                this.getButton('add')),
            this.getValidationMessage()));
    };
    InputStepper.prototype.getButton = function (iconName) {
        var addButtonEnabled = iconName === 'add';
        var classes = addButtonEnabled ? this.getAddButtonClassNames() : this.getSubtractButtonClassNames();
        var ariaLabel = addButtonEnabled ? 'Increment' : 'Decrement'; //FIXME: LOCALIZE THIS
        return (react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.ROUND, variant: this.props.buttonVariant, classes: classes, onClick: this.handleIncrementalChange, "aria-label": ariaLabel },
            react_1.default.createElement(Icon_1.default, { name: iconName })));
    };
    InputStepper.prototype.getValidationMessage = function () {
        var _a = this.props, validationMessage = _a.validationMessage, validationState = _a.validationState;
        var invalid = this.props.invalid || this.state.invalid;
        return (react_1.default.createElement(ValidationMessage_1.default, { validationMessage: validationMessage, validationState: invalid ? FieldValidationState_1.FieldValidationState.INVALID : validationState }));
    };
    InputStepper.prototype.isInvalidInput = function (value) {
        return isNaN(value) || (value < this.props.min || value > this.props.max);
    };
    InputStepper.prototype.getClassNames = function () {
        var _a = this.props, classes = _a.classes, validationState = _a.validationState;
        var invalid = this.state.invalid;
        return classnames_1.default('fds-field fds-field-input-stepper', {
            invalid: invalid || validationState === FieldValidationState_1.FieldValidationState.INVALID,
            valid: validationState === FieldValidationState_1.FieldValidationState.VALID
        }, classes);
    };
    InputStepper.prototype.getSubtractButtonClassNames = function () {
        var disabled = Number(this.state.value) <= this.props.min || this.props.disabled;
        return classnames_1.default('button-remove', {
            'is-disabled': disabled
        });
    };
    InputStepper.prototype.getAddButtonClassNames = function () {
        var disabled = Number(this.state.value) >= this.props.max || this.props.disabled;
        return classnames_1.default('button-add', {
            'is-disabled': disabled
        });
    };
    InputStepper.defaultProps = {
        buttonVariant: Button_1.RoundButtonType.FLAT,
        invalid: false
    };
    return InputStepper;
}(react_1.default.Component));
exports.default = InputStepper;
